import React, { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { green, orange, red } from '@ant-design/colors';
import { Button, Checkbox, Drawer, Form, Input, message, Progress, Select, Space, Tooltip, TreeSelect } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { addAccount, modifyAccount } from '../../../../../../api/account/account';
import { AccountVO } from '../../../../../../api/account/types';
import { getDeptTreeApi } from '../../../../../../api/dept/dept';
import { DeptVO } from '../../../../../../api/dept/types';
import { getRoleListApi } from '../../../../../../api/role/role';
import { RoleVO } from '../../../../../../api/role/types';
import { getShopListApi } from '../../../../../../api/shop/shop';
import { ShopVO } from '../../../../../../api/shop/types';
import { AccountSourceEnum } from '../../../../../../enums/AccountStatusEnum';
import { state } from '../../../../../../store';
import busEvent from '../../../../../../utils/bus';
import { emailVal, highStrengthLevel, middleStrengthLevel, mobileVal } from '../../../../../../utils/verifyTool';
// import './index.css'
import style from './index.module.scss';

type FieldType = {
  accountName: string;
  password: string;
  nickName: string;
  deptId: number;
  shopIds: number[];
  email: string;
  phoneNumber: string;
  roleId: number;
  channelDataType?: any;
};

let userId: number | string;

let accountItem: AccountVO;

let CreateAccountDrawer = React.forwardRef(
  (
    props: {
      createSuccess?: Function;
      editDrawerOpen?: Function;
      type: string;
    },
    ref: any,
  ) => {
    // const [messageApi, contextHolder] = message.useMessage();
    //防连点
    const [clickStatus, setClickStatus] = useState(false);
    const [accountForm] = Form.useForm();
    const [open, setOpen] = useState(false);
    //部门列表
    const [deptList, setDeptList] = useState([] as DeptVO[]);
    //店铺列表
    const [shopList, setShopList] = useState([] as ShopVO[]);
    const shopListRef = useRef<ShopVO[]>([]);
    //角色列表
    const [roleList, setRoleList] = useState([] as RoleVO[]);
    //密码强度
    const [passwordPercent, setPasswordPercent] = useState(0);
    const [passwordColor, setPasswordColor] = useState([] as any[]);

    const [defaultDeptId, setDefaultDeptId] = useState(null as unknown as number | string);
    //店铺
    const [shopIds, setShopIds] = useState([] as any);
    const [shopSelectAll, setShopSelectAll] = useState(false);
    const currentShopIdsRef = useRef<string[]>([]);
    const [shopIdsBeforeSuperAdmin, setShopIdsBeforeSuperAdmin] = useState<string[]>([]);
    const [selectedRoleIds, setSelectedRoleIds] = useState<number[]>([]);
    const [superAdminRoleIds, setSuperAdminRoleIds] = useState<number[]>([]);
    const [isSuperAdminRoleSelected, setIsSuperAdminRoleSelected] = useState(false);
    const superAdminRoleIdsRef = useRef<number[]>([]);
    //生产线
    //编辑的时候 初始化的密码
    const [oldPaddword, setOldPaddword] = useState(null as any);
    //编辑的时候 初始化的邮箱
    const [oldEmail, setOldEmail] = useState(null as any);
    //登录的时候 是否邮箱必填
    const [bindEmail, setBindEmail] = useState(localStorage.getItem('accessType') == 'EMAIL');
    //登录的时候 是否邮箱必填
    const [bindPhone, setBindPhone] = useState(localStorage.getItem('accessType') == 'PHONE');
    const createDrawerClose = () => {
      setOpen(false);
    };
    const createDrawerOpen = (arr: string[]) => {
      userId = '';
      setSelectedRoleIds([]);
      setIsSuperAdminRoleSelected(false);
      setShopIdsBeforeSuperAdmin([]);
      initData('CREATE');
      console.log(arr);

      if (arr && arr.length > 0) {
        setDefaultDeptId(parseInt(arr[0]));
        accountForm.setFieldValue('deptId', parseInt(arr[0]));
      } else {
        setDefaultDeptId('');
        accountForm.setFieldValue('deptId', null);
      }
      accountForm.setFieldValue('accountName', '');
      accountForm.setFieldValue('nickName', '');
      const defaultPwd = generateStrongPassword();
      accountForm.setFieldValue('password', defaultPwd);
      handlePasswordInputChange({ target: { value: defaultPwd } });
      setShopIds([]);
      setShopSelectAll(false);
      currentShopIdsRef.current = [];
      accountForm.setFieldValue('shopIds', []);
      setPasswordPercent(0);
      accountForm.setFieldValue('phoneNumber', '');
      accountForm.setFieldValue('email', '');
      accountForm.setFieldValue('roleId', []);
    };

    const editDrawerOpen = async (item: AccountVO, type: string) => {
      userId = item.userId;
      accountItem = item;
      setSelectedRoleIds([]);
      setIsSuperAdminRoleSelected(false);
      setShopIdsBeforeSuperAdmin([]);
      currentShopIdsRef.current = [];
      await initData('EDIT');
      accountForm.setFieldValue('accountName', item.userName);
      setDefaultDeptId(item.deptId || 0);
      accountForm.setFieldValue('deptId', item.deptId);

      accountForm.setFieldValue('phoneNumber', item.phoneNumber);
      setOldPaddword(item.phoneNumber);
      accountForm.setFieldValue('nickName', item.nickName);
      accountForm.setFieldValue('email', item.email);
      setOldEmail(item.email);
      let a: number[] = [];
      if (accountItem.roleIds) {
        accountItem.roleIds?.split(',').map(item => {
          a.push(parseInt(item));
        });
      }
      setSelectedRoleIds(a);
      accountForm.setFieldValue('roleId', a);
      evaluateSuperAdminSelection(a);
    };

    const collectAllShopValues = (list?: any[]) => {
      const source = Array.isArray(list) ? list : shopListRef.current;
      const values: string[] = [];
      source.forEach((channel: any) => {
        channel?.shop?.forEach((shopItem: any) => {
          if (shopItem?.value) {
            values.push(shopItem.value);
          }
        });
      });
      return values;
    };

    const updateShopSelectionState = (values: string[], totalCount?: number, list?: any[]) => {
      const normalizedValues = Array.isArray(values) ? [...values] : [];
      currentShopIdsRef.current = normalizedValues;
      setShopIds(normalizedValues);
      accountForm.setFieldValue('shopIds', normalizedValues);
      const count = typeof totalCount === 'number' ? totalCount : collectAllShopValues(list).length;
      setShopSelectAll(count > 0 && normalizedValues.length === count);
    };

    const forceSelectAllShops = (list?: any[]) => {
      const allValues = collectAllShopValues(list);
      updateShopSelectionState(allValues, allValues.length, list);
    };

    const syncSuperAdminLock = (nextRoleHasSuper: boolean) => {
      const wasLocked = isSuperAdminRoleSelected;
      const willLock = nextRoleHasSuper;
      if (willLock) {
        if (!wasLocked) {
          const currentShopIds = Array.isArray(currentShopIdsRef.current) ? currentShopIdsRef.current : [];
          setShopIdsBeforeSuperAdmin([...currentShopIds]);
        }
        forceSelectAllShops();
      } else if (wasLocked && !willLock) {
        const restoreValues = shopIdsBeforeSuperAdmin.length ? shopIdsBeforeSuperAdmin : [];
        updateShopSelectionState(restoreValues);
        setShopIdsBeforeSuperAdmin([]);
      }
      setIsSuperAdminRoleSelected(nextRoleHasSuper);
    };

    const evaluateSuperAdminSelection = (roleValues: number[]) => {
      const includesSuperAdmin = roleValues.some(roleId => superAdminRoleIdsRef.current.includes(roleId));
      syncSuperAdminLock(includesSuperAdmin);
    };

    const handleRoleSelectChange = (value: number[], option?: any) => {
      const roleValues = value || [];
      setSelectedRoleIds(roleValues);
      accountForm.setFieldValue('roleId', roleValues);
      evaluateSuperAdminSelection(roleValues);
    };

    const initData = async (type: string) => {
      setOpen(true);
      await getDeptList();
      await getShopList(type);
      await getRoleList();
    };

    useEffect(() => {}, []);

    //获取所有部门
    const getDeptList = async () => {
      const res = await getDeptTreeApi();
      if (res) {
        const list = res.data[0].children as any[];
        prepareData(list);
        setDeptList(list);
      }
    };

    const prepareData = (arr: any[]) => {
      arr.map(item => {
        item.title = item.label;
        item.value = item.id;
        if (item.children && item.children.length > 0) {
          prepareData(item.children);
        }
      });
    };

    // 皇家看板店铺名映射关系
    const shopNameForDataBoard = new Map([
      ['105018077', '【天猫】日粮旗舰店'],
      ['10000001', '【微信】小程序商城'],
      ['1000001706', '【京东】日粮自营店'],
      ['66696926', '【抖音】日粮旗舰店'],
      ['210259195', '【天猫】处方粮旗舰店'],
    ]);
    const getLabel = (id: string, name: string): string => {
      return shopNameForDataBoard.has(id) ? (shopNameForDataBoard.get(id) as string) : name;
    };
    //获取所有店铺
    const getShopList = async (type: string) => {
      const res = await getShopListApi();
      if (res) {
        const list = res.data;
        list.map((item: any) => {
          item.title = item.sysChannelName;
          item.value = item.sysChannelId;
          item.children = item.shop;
          item.key = item.id;
          item.children?.map((itm: any) => {
            itm.title = getLabel(itm.platformShopId, itm.shopName);
            // itm.title = itm.shopName;
            itm.value = item.value + '-' + itm.platformShopId;
          });
        });
        // 隐藏没有店铺的渠道
        const filteredData = list.filter(item => item.children !== null);
        shopListRef.current = filteredData;
        setShopList(filteredData);
        if (type !== 'CREATE') {
          let shopIdsArr: string[] = [];
          let totalCount = 0;
          list.map((item: any) => {
            if (item.shop) {
              totalCount += item.shop.length;
              item.shop.map((itm: any) => {
                accountItem.shopIds?.split(',').map(im => {
                  if (itm.platformShopId == im) {
                    shopIdsArr.push(itm.value);
                  }
                });
              });
            }
          });
          updateShopSelectionState(shopIdsArr, totalCount, filteredData);
        }
      }
    };

    //获取所有产品线
    //获取所有角色
    const getRoleList = async () => {
      const res = await getRoleListApi();
      if (res) {
        const list = res.data;
        list.map(item => {
          item.label = item.roleName;
          item.value = item.roleId;
        });
        setRoleList(list);
        const superAdminIds = list.filter((item: any) => item.superAdmin).map((item: any) => item.roleId);
        setSuperAdminRoleIds(superAdminIds);
        superAdminRoleIdsRef.current = superAdminIds;
      }
    };
    useImperativeHandle(ref, () => ({
      createDrawerOpen,
      editDrawerOpen,
    }));
    interface Param {
      userName: string;
      password: string;
      nickName: string;
      deptId: string;
      email: string;
      phoneNumber: string;
      userRoleIds: string;
      userId: any;
      brandIds?: any;
      shopIds?: string[];
    }
    const handleCreateClick = async () => {
      console.log(accountForm.getFieldValue('deptId'));

      if (!accountForm.getFieldValue('accountName')) {
        showErrorMessage('账号名称不能为空');
        return;
      } else {
        // const reg: any = '^[\u4E00-\u9FA5A-Za-z0-9][\u4E00-\u9FA5A-Za-z0-9-、 _]*$';
        var pattern1 = /^[a-zA-Z0-9\u4e00-\u9fa5\-_、\\]+$/;
        // 使用正则表达式匹配中文、英文或数字开头的字符串
        var pattern = /^[a-zA-Z0-9\u4e00-\u9fa5]/;
        console.log(
          pattern.test(accountForm.getFieldValue('accountName')),
          'pattern.test(accountForm.getFieldValue(accountName))',
        );
        // debugger

        // if((accountForm.getFieldValue('accountName').match(reg, '') === null && !/\\/.test(accountForm.getFieldValue('accountName'))) || !pattern.test(accountForm.getFieldValue('accountName'))){
        if (
          !pattern1.test(accountForm.getFieldValue('accountName')) ||
          !pattern.test(accountForm.getFieldValue('accountName'))
        ) {
          showErrorMessage('账号名称以中文、英文、数字开头，支持中文、英文、数字和部分符号（-、\\ _）');
          return;
        }
      }

      if (accountForm.getFieldValue('accountName').length < 5) {
        showErrorMessage('账号名称至少需要5个字符');
        return;
      }
      if (props.type !== 'EDIT') {
        if (!accountForm.getFieldValue('password')) {
          showErrorMessage('初始密码不能为空');
          return;
        }
        if (accountForm.getFieldValue('password').length < 8) {
          showErrorMessage('初始密码至少需要8个字符');
          return;
        }
      }
      if (!accountForm.getFieldValue('nickName')) {
        showErrorMessage('请输入姓名');
        return;
      }
      if (!accountForm.getFieldValue('deptId')) {
        showErrorMessage('请选择所属组织');
        return;
      }
      if (shopIds.length === 0) {
        showErrorMessage('至少选择一个店铺');
        return;
      }
      // 所有state.dataPermission==='0' 的判断为 所属店铺之前的隐藏内容
      var status = 0;
      if (accountForm.getFieldValue('phoneNumber') && accountForm.getFieldValue('phoneNumber') != oldPaddword) {
        if (!mobileVal(accountForm.getFieldValue('phoneNumber'))) {
          showErrorMessage('输入正确手机号');
          status = 1;
          return;
        }
      }
      if (accountForm.getFieldValue('email') && accountForm.getFieldValue('email') != oldEmail) {
        if (!emailVal(accountForm.getFieldValue('email'))) {
          showErrorMessage('输入正确邮箱');
          status = 1;
          return;
        }
      }
      if (status) {
        return;
      }
      if (!accountForm.getFieldValue('roleId').length) {
        showErrorMessage('请选择功能角色');
        return;
      }
      if (clickStatus) {
        return;
      }
      setClickStatus(true);
      var arr = [] as any;
      shopIds.map((item: any) => {
        arr.push(Number(item.split('-')[1]));
      });
      const param: Param = {
        userName: accountForm.getFieldValue('accountName'),
        password: props.type === 'CREATE' ? accountForm.getFieldValue('password') : '',
        nickName: accountForm.getFieldValue('nickName'),
        deptId: accountForm.getFieldValue('deptId'),
        email:
          oldEmail == accountForm.getFieldValue('email') && accountForm.getFieldValue('email')
            ? '0'
            : accountForm.getFieldValue('email'),
        phoneNumber:
          oldPaddword == accountForm.getFieldValue('phoneNumber') && accountForm.getFieldValue('phoneNumber')
            ? '0'
            : accountForm.getFieldValue('phoneNumber'),
        userRoleIds: accountForm.getFieldValue('roleId'),
        userId,
      };
      param.shopIds = arr;
      // 所有state.dataPermission==='0' 的判断为 所属店铺之前的隐藏内容
      if (props.type === 'CREATE') {
        const res = await addAccount(param);
        if (res) {
          message.success('账号创建成功');
          if (props.createSuccess) {
            props.createSuccess();
          }
          createDrawerClose();
        }
        setClickStatus(false);
      } else if (props.type === 'EDIT') {
        const res = await modifyAccount(param);
        if (res) {
          busEvent.emit('updateUserDetail');
          message.success('账号修改成功');
          if (props.createSuccess) {
            props.createSuccess();
          }
          createDrawerClose();
        }
        setClickStatus(false);
      }
    };

    const handlePasswordInputChange = (e: any) => {
      let password = e.target.value;
      password = password.replace(/\s*/g, '').replace(/[\u4e00-\u9fa5]/g, ''); // 匹配非中文字符的正则表达式
      accountForm.setFieldValue('password', password);
      if (highStrengthLevel(password)) {
        setPasswordPercent(100);
        setPasswordColor([red[0], orange[0], green[3]]);
      } else if (middleStrengthLevel(password)) {
        setPasswordPercent(66);
        setPasswordColor([red[0], orange[3], green[0]]);
      } else if (!password) {
        setPasswordPercent(0);
        setPasswordColor([red[0], orange[0], green[0]]);
      } else {
        setPasswordPercent(33);
        setPasswordColor([red[3], orange[0], green[0]]);
      }
    };

    const generateStrongPassword = () => {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%^&*';
      let pwd = '';
      while (pwd.length < 12) {
        pwd += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return pwd;
    };

    const showErrorMessage = (str: string) => {
      message.error(str);
    };

    //选择店铺
    const handleShopSelect = (value: string[]) => {
      if (isSuperAdminRoleSelected) {
        forceSelectAllShops();
        return;
      }
      const selectedValues = value || [];
      updateShopSelectionState(selectedValues);
    };

    //店铺全选
    const handleShopSelectAllClick = () => {
      if (isSuperAdminRoleSelected) {
        return;
      }
      if (shopSelectAll) {
        updateShopSelectionState([]);
      } else {
        forceSelectAllShops();
      }
    };

    const handleKeyDown = (event: any) => {
      if (event.keyCode === 32) {
        event.preventDefault();
      }
    };
    const clearRoleSelection = () => {
      setSelectedRoleIds([]);
      accountForm.setFieldValue('roleId', []);
    };

    return (
      <div>
        {open && (
          <Drawer
            width={420}
            styles={{ body: { overflowX: 'hidden' } }}
            title={`${props.type === 'CREATE' ? '新建' : props.type === 'EDIT' ? '编辑' : '查看'}账号`}
            onClose={createDrawerClose}
            open={open}
            extra={
              props.type !== 'CHECK' && (
                <Space>
                  <Button onClick={createDrawerClose}>取消</Button>
                  <Button
                    type="primary"
                    onClick={handleCreateClick}>
                    确定
                  </Button>
                </Space>
              )
            }>
            <Form
              layout="vertical"
              form={accountForm}
              disabled={props.type === 'CHECK'}>
              <Form.Item<FieldType>
                label="账号名称"
                name="accountName"
                rules={[{ required: true }]}>
                <Input
                  placeholder="请输入账号名称"
                  onKeyDown={handleKeyDown}
                  showCount
                  maxLength={20}
                />
              </Form.Item>
              {props.type === 'CREATE' && (
                <Form.Item<FieldType>
                  label="初始密码"
                  name="password"
                  rules={[{ required: true }]}>
                  <Input.Password
                    onChange={handlePasswordInputChange}
                    value={accountForm.getFieldValue('password')}
                    placeholder="请输入初始密码"
                    onKeyDown={handleKeyDown}
                    showCount
                    maxLength={32}
                    minLength={8}
                  />
                  <div style={{ fontSize: 'var(--text-font2)', marginTop: '5px' }}>
                    密码强度
                    <Progress
                      showInfo={false}
                      percent={passwordPercent}
                      steps={3}
                      strokeColor={passwordColor}
                    />
                  </div>
                </Form.Item>
              )}
              <Form.Item<FieldType>
                label="姓名"
                name="nickName"
                rules={[{ required: true }]}>
                <Input
                  autoComplete="off"
                  placeholder="请输入姓名"
                  maxLength={20}
                  count={{ max: 20, show: true }}
                />
              </Form.Item>
              <Form.Item<FieldType>
                rules={[{ required: true }]}
                label="所属组织"
                name="deptId">
                <TreeSelect
                  showSearch
                  style={{ width: '100%' }}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="请选择"
                  allowClear
                  treeData={deptList}
                  treeNodeFilterProp="title"
                />
              </Form.Item>
              {/* {state.dataPermission === '0' && ( */}
              <Form.Item<FieldType>
                label="所属店铺"
                name="shopIds"
                rules={[{ required: true }]}>
                <div className={style['CreateAccount_form-item-horizontal']}>
                  <TreeSelect
                    showSearch
                    style={{ width: 260 }}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="请选择"
                    allowClear
                    treeCheckable
                    value={shopIds}
                    disabled={isSuperAdminRoleSelected}
                    treeData={shopList}
                    onChange={handleShopSelect}
                    treeNodeFilterProp="title"
                  />
                  <Checkbox
                    style={{ marginLeft: 12 }}
                    checked={shopSelectAll}
                    disabled={isSuperAdminRoleSelected}
                    onChange={handleShopSelectAllClick}>
                    全选店铺
                  </Checkbox>
                </div>
              </Form.Item>
              {/* )} */}

              <Form.Item<FieldType>
                label="绑定手机号"
                name="phoneNumber"
                rules={[{ required: bindPhone }]}>
                <Input
                  placeholder="请输入手机号"
                  autoComplete="off"
                  maxLength={11}
                  count={{ max: 11, show: true }}
                />
              </Form.Item>
              <Form.Item<FieldType>
                label="绑定邮箱"
                name="email"
                rules={[{ required: bindEmail }]}>
                <Input
                  autoComplete="off"
                  placeholder="请输入邮箱"
                />
              </Form.Item>
              <Form.Item<FieldType>
                label="功能角色"
                name="roleId"
                rules={[{ required: true, message: '请选择功能角色' }]}>
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="请选择"
                  options={roleList}
                  optionFilterProp={'label'}
                  value={selectedRoleIds}
                  onChange={handleRoleSelectChange}
                />
              </Form.Item>
            </Form>
          </Drawer>
        )}
      </div>
    );
  },
);
export default CreateAccountDrawer;
